import React, { useState, useEffect, useCallback } from 'react';
import { reduxForm, Field } from 'redux-form';
import { Row, Col, Button, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import ReactPanZoom from "@ajainarayanan/react-pan-zoom";
import ReactTable from "react-table";
import ScrollArea from 'react-scrollbar';
import update from 'immutability-helper';

import AssetImageGallery from './asset_image_gallery';
import { TextInput } from '../TextInput';
import { SelectInput } from '../SelectInput';
import { AssetTypesService, TagsService, GroupingsService, DevicesService, ContentService } from '../../services';
import { OpSenseToastContainer, toast } from '../Toast';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faMapPin from '@fortawesome/fontawesome-free-solid/faMapPin';
import { BaseTable } from '../../helpers';

const validate = values => {
  const errors = {};

  if (!values.name) {
    errors.name = i18next.t('messages.please-enter-asset-name');
  }

  if (!values.businessGroup) {
    errors.businessGroup = i18next.t('messages.please-selected-business-group');
  }

  return errors;
};

@connect(state => {
  return {
    form: state.form
  }
})
class AssetForm extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      availableAssetTypes: null,
      availableBusinessGroups: null,
      availableGenericTags: null,
      availableAreaTags: null,
      selectedAssetType: null,
      measures: null,
      removedMeasures: [],
      showAssignDeviceToMeasureModal: false,
      assigningMeasure: null,
      showAssignAssetToFloorplanModal: false,
      floorPlanURL: null,
      floorPlanLocation: {x:-1, y:-1},
      showAddAssetImageModal: false,
      assetImages: [],
      editing: false
    }

    if (props.asset) {
      const asset = props.asset;
      this.state.editing = true;
      this.state.selectedAssetType = asset.assetType;
      this.state.floorPlanURL = props.floorPlanURL;
      this.state.assetImages = props.assetImages;
      this.state.selectedBusinessGroupId = this.props.asset.businessGroup.id;

      if(asset.floorPlanX != -1) {
        this.state.floorPlanLocation = {x:asset.floorPlanX, y:asset.floorPlanY};
      }

      let initData = {
        name: asset.name
      }

      let measures = asset.assetType.measures.map((assetTypeDeviceDataType) => ({id: null, name: assetTypeDeviceDataType.name, assetTypeDeviceDataType: assetTypeDeviceDataType, device: null}));
      measures.sort((a, b) => (a.assetTypeDeviceDataType.displayOrder === b.assetTypeDeviceDataType.displayOrder) ? 0 : ((a.assetTypeDeviceDataType.displayOrder < b.assetTypeDeviceDataType.displayOrder) ? -1 : 1) );
      measures.forEach((measure) => {
        const foundMeasure = asset.assetMeasures.find((existingMeasure) => existingMeasure.assetTypeDeviceDataType.id == measure.assetTypeDeviceDataType.id);
        if (foundMeasure) {
          measure.id = foundMeasure.id;
          measure.device = foundMeasure.device;
          measure.deviceDataType = foundMeasure.deviceDataType;
          measure.startAt = foundMeasure.startAt;
          if (foundMeasure.name) {
            measure.name =  foundMeasure.name;
          } else {
            measure.name = measure.assetTypeDeviceDataType.name;
          }
        }
      });
      this.state.measures = measures;
      initData.measures = measures;
      initData.removedMeasures = [];

      const genericTags = asset.tags.filter(tag => tag.tagType.token === 'generic');
      initData.genericTags = genericTags.map(tag => ({ value: tag.id, label: tag.name, tag: tag }));

      const areaTag = asset.tags.find(tag => tag.tagType.token === 'area');
      if (areaTag) {
        initData.areaTag = { value: areaTag.id, label: areaTag.name, tag: areaTag };
      }

      asset.assetMetadata.forEach(item => {
        if (item.assetTypeMetadataType.stringValueFlag) {
          initData[`metadata-${item.assetTypeMetadataType.id}`] = item.stringValue;
        } else {
          initData[`metadata-${item.assetTypeMetadataType.id}`] = item.numericValue;
        }
      });

      this.props.initialize(initData);
    }
  }

  componentDidMount() {
    TagsService.listAll().then((response) => {
      this.setState({ 
        availableGenericTags: response.tags.filter(tag => tag.tagType.token === 'generic').map(tag => ({ value: tag.id, label: tag.name, tag: tag })),
        availableAreaTags: response.tags.filter(tag => tag.tagType.token === 'area').map(tag => ({ value: tag.id, label: tag.name, tag: tag }))
      });
    }).catch((error) => {
      console.error(error);
      toast.error(error)
    });

    if (!this.state.editing) {
      AssetTypesService.listAll().then((response) => {
        this.setState({ availableAssetTypes: response.assetTypes.map(assetType => ({ assetType: assetType.id, label: assetType.name, assetType: assetType })) });
      }).catch((error) => {
        console.error(error);
        toast.error(error)
      });

      GroupingsService.listAll().then((response) => {
        this.setState({ availableBusinessGroups: response.groupings.map(businessGroup => ({ value: businessGroup.id, label: businessGroup.name, businessGroup: businessGroup })) });
      }).catch((error) => {
        console.error(error);
        toast.error(error)
      });
    }
  }

  businessGroupSelected(businessGroupSelection) {
    this.setState({ 
      selectedBusinessGroupId: businessGroupSelection.value,
      measures: this.state.measures ? this.state.measures.map((measure) => {
        measure.device = null;
        return measure;
      }) : null
    });

    ContentService.getDeviceGroupingFloorplanImage(businessGroupSelection.value).then((floorPlanURL) => {
      this.setState({floorPlanURL: floorPlanURL});
    });
  }

  assetTypeSelected(assetType) {    
    let measures = assetType.measures.map((assetTypeDeviceDataType) => ({ id: null, name: assetTypeDeviceDataType.name, assetTypeDeviceDataType: assetTypeDeviceDataType, device: null }));
    measures.sort((a, b) => (a.assetTypeDeviceDataType.displayOrder === b.assetTypeDeviceDataType.displayOrder) ? 0 : ((a.assetTypeDeviceDataType.displayOrder < b.assetTypeDeviceDataType.displayOrder) ? -1 : 1) );
    this.setState({ 
      selectedAssetType: assetType,
      measures: measures
    }, () => {
      const areaTag = assetType.defaultTags.find(tag => tag.tagType.token === 'area');
      const genericTags = assetType.defaultTags.filter(tag => tag.tagType.token === 'generic');
      this.props.change('genericTags', genericTags.map(tag => ({ value: tag.id, label: tag.name, tag: tag })));
      if (areaTag) {
        this.props.change('areaTag', { value: areaTag.id, label: areaTag.name, tag: areaTag });
      }
      this.props.change('measures', measures);
      this.props.change('removedMeasures', []);
    });
  }

  assignDeviceToMeasureModalToggle(measure) {
    this.setState({
      showAssignDeviceToMeasureModal: !this.state.showAssignDeviceToMeasureModal,
      assigningMeasure: measure
    });
  }

  removeMeasure(measure, deviceDataType) {
    const index = this.state.measures.findIndex((existingMeasure) => existingMeasure.id === measure.id);
    if (index != -1) {
      const removedMeasure = update(this.state.measures[index], { endAt: {$set: Date.now()} });
      const newMeasure = update(measure, { id: {$set: null}, device: {$set: null}, deviceDataType: {$set: deviceDataType}, assetTypeDeviceDataType: {$set: measure.assetTypeDeviceDataType} });
      this.setState({
        measures: update(this.state.measures, {$splice: [[index, 1, newMeasure]]}),
        removedMeasures: update(this.state.removedMeasures, {$push: [removedMeasure]})
      }, () => {
        this.props.change('measures', this.state.measures);
        this.props.change('removedMeasures', this.state.removedMeasures);
      }); 
    }
  }
  
  assignDeviceToMeasure(device, deviceDataType, measure) {
    if (measure.device != null && measure.deviceDataType != null && measure.id != null && this.state.editing) {
       // Assigning the same device device type
      if (measure.device.id == device.id && measure.deviceDataType.id == deviceDataType.id) {
        this.assignDeviceToMeasureModalToggle(null);
        return;
      }

      const index = this.state.measures.findIndex((existingMeasure) => existingMeasure.id === measure.id);
      if (index != -1) {
        const removedMeasure = update(this.state.measures[index], { endAt: {$set: Date.now()} });
        const newMeasure = update(measure, { id: {$set: null}, device: {$set: device}, deviceDataType: {$set: deviceDataType}, assetTypeDeviceDataType: {$set: measure.assetTypeDeviceDataType}, startAt: {$set: removedMeasure.endAt} });

        this.setState({
          measures: update(this.state.measures, {$splice: [[index, 1, newMeasure]]}),
          removedMeasures: update(this.state.removedMeasures, {$push: [removedMeasure]})
        }, () => {
          this.props.change('measures', this.state.measures);
          this.props.change('removedMeasures', this.state.removedMeasures);
        }); 
      }
    } else { // adding new
      const removedIndex = this.state.removedMeasures.findIndex((removedMeasure) => 
              removedMeasure.device.id === device.id && removedMeasure.deviceDataType.id === measure.deviceDataType.id
            );
      if (removedIndex != -1) { // re-adding a removed measure
        const removedMeasure = this.state.removedMeasures[removedIndex];
        const newMeasure = update(measure, { id: {$set: removedMeasure.id}, device: {$set: device}, deviceDataType: {$set: deviceDataType}, assetTypeDeviceDataType: {$set: measure.assetTypeDeviceDataType}, startAt: {$set: removedMeasure.startAt}, endAt: {$set: null} });

        const index = this.state.measures.findIndex((existingMeasure) => existingMeasure.assetTypeDeviceDataType.id === measure.assetTypeDeviceDataType.id);
        if (index != -1) {
          this.setState({
            measures: update(this.state.measures, {$splice: [[index, 1, newMeasure]]}),
            removedMeasures: update(this.state.removedMeasures, {$splice: [[removedIndex, 1]]})
          }, () => {
            this.props.change('measures', this.state.measures);
            this.props.change('removedMeasures', this.state.removedMeasures);
          });         
        }
      } else {
        const newMeasure = update(measure, { id: {$set: null}, device: {$set: device}, deviceDataType: {$set: deviceDataType}, assetTypeDeviceDataType: {$set: measure.assetTypeDeviceDataType}, startAt: {$set: Date.now()} });

        const index = this.state.measures.findIndex((existingMeasure) => existingMeasure.assetTypeDeviceDataType.id === measure.assetTypeDeviceDataType.id);
        if (index != -1) {
          this.setState({
            measures: update(this.state.measures, {$splice: [[index, 1, newMeasure]]})
          }, () => {
            this.props.change('measures', this.state.measures);
          }); 
        }
      }
    }

    this.assignDeviceToMeasureModalToggle(null);
  }

  assignAssetToFloorplanModalToggle() {
    this.setState({
      showAssignAssetToFloorplanModal: !this.state.showAssignAssetToFloorplanModal,
    });
  }

  setFloorPlanLocation(location) {
    this.setState({floorPlanLocation: location});
    this.props.onFloorplanLocationChange(location);
  }  

  render() {
    const { handleSubmit, invalid, submitting, onAssetImageChange } = this.props;
    const readyToSave = this.state.selectedAssetType != null;

    if (this.state.availableAreaTags && (this.state.editing || (this.state.availableAssetTypes && this.state.availableBusinessGroups))) {
      return (
        <div className="login-form tag-form op-content-box">
          <OpSenseToastContainer />

          <form onSubmit={handleSubmit}>
            <Row>
              <Col xs={12} sm={4}>
                <div className="form-tag">
                  <Field name="name" type="text" component={TextInput} label={i18next.t('form-labels.name')} />
                </div>
              </Col>
              <Col xs={12} sm={4}>
                <div className="form-tag">
                  <label>{i18next.t('pages.assets.business-group')}</label>
                  { 
                    this.state.editing ?
                    <span>{this.props.asset.businessGroup.name}</span> :
                    <Field name="businessGroup" options={this.state.availableBusinessGroups} component={SelectInput} onChange={this.businessGroupSelected.bind(this)} />
                  }
                </div>
              </Col>
              <Col xs={12} sm={4}>
                <div className="form-tag">
                  <label>{i18next.t('pages.assets.type')}</label>
                  { 
                    this.state.editing ?
                    <span>{this.props.asset.assetType.name}</span> :
                    <Field name="assetType" options={this.state.availableAssetTypes} component={SelectInput} onChange={(assetTypeSelection) => this.assetTypeSelected(assetTypeSelection.assetType)} /> 
                  }
                </div>
              </Col>
            </Row>

            { 
              (this.state.selectedAssetType && this.state.selectedBusinessGroupId) || this.state.editing ? 
                <AssetTypeSpecificFormArea 
                  availableAreaTags={this.state.availableAreaTags} 
                  availableGenericTags={this.state.availableGenericTags} 
                  measures={this.state.measures} 
                  metadataTypes={this.state.editing ? this.props.asset.assetType.assetTypeMetadataTypes : this.state.selectedAssetType.assetTypeMetadataTypes}
                  toggleMeasureModal={this.assignDeviceToMeasureModalToggle.bind(this)} 
                  toggleFloorplanModal={this.assignAssetToFloorplanModalToggle.bind(this)}
                  removeMeasure={this.removeMeasure.bind(this)}
                  assetImages={this.state.assetImages} 
                  onAssetImageChange={(assetImages) => { onAssetImageChange(assetImages); this.setState({assetImages: assetImages}); }}        
                  floorplanLocation={this.state.floorPlanLocation}
                  floorplanRequired={this.state.selectedAssetType && this.state.selectedAssetType.requiresFloorplan}
                /> : null 
            }

            <ul style = {{paddingTop: 20}} className="list-inline clearfix">
              <li><button type="submit" className="btn btn-primary" disabled={invalid || submitting || !readyToSave}>{i18next.t('form-labels.save')}</button></li>
              <li><Link to={ this.props.backLinkWithParams ? this.props.backLinkWithParams.link : `/config/assets`}><button className="btn btn-default">{i18next.t('form-labels.cancel')}</button></Link></li>
            </ul>            
          </form>

          <AssignDeviceToMeasureModal 
            show={this.state.showAssignDeviceToMeasureModal} 
            toggleModal={this.assignDeviceToMeasureModalToggle.bind(this)} 
            assignAction={this.assignDeviceToMeasure.bind(this)}
            businessGroupId={this.state.selectedBusinessGroupId}
            assigningMeasure={this.state.assigningMeasure}
          />

          { 
            this.state.floorPlanURL && this.state.selectedAssetType && this.state.selectedAssetType.requiresFloorplan ? 
              <AssetFloorplanModal 
                show={this.state.showAssignAssetToFloorplanModal} 
                toggleModal={this.assignAssetToFloorplanModalToggle.bind(this)}
                floorPlanURL={this.state.floorPlanURL}
                originalLocation={this.state.floorPlanLocation}
                onSave={this.setFloorPlanLocation.bind(this)}
              /> : null
          }
        </div>
      );
    } else {
      return (
        <div>
          <OpSenseToastContainer />

          <div className="loader">{i18next.t('loading')}</div>
        </div>
      );
    }
  }
}

const AssetFloorplanModal = ({show, toggleModal, floorPlanURL, originalLocation, onSave}) => {
  const [location, setLocation] = useState(originalLocation);

  return (
      <Modal show={show} onHide={toggleModal} dialogClassName="op-floor-plan-modal">
          <Modal.Header closeButton>
            <Modal.Title>{i18next.t('pages.assets.asset-location')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ZoomPanFloorplan 
              floorPlanURL={floorPlanURL} 
              originalLocation={location} 
              onLocationChange={(location) => {setLocation(location)}}
            />
          </Modal.Body>
          <Modal.Footer>
            <a className="btn btn-default" onClick={() => {onSave(location); toggleModal();}}>{i18next.t('save')}</a>
            <Button onClick={() => {setLocation(originalLocation); toggleModal();}}>{i18next.t('form-labels.cancel')}</Button>
          </Modal.Footer>
      </Modal>
  );
}

const ZoomPanFloorplan = ({floorPlanURL, originalLocation, onLocationChange}) => {
  const [location, setLocation] = useState(originalLocation);
  const [zoom, setZoom] = useState(1);
  const [mouseDown, setMouseDown] = useState(null);
  const [mouseMoved, setMouseMoved] = useState(false);
  const dropPin = () => {
    if (!mouseMoved) {
      onLocationChange(mouseDown);
      setLocation(mouseDown);
    }
    setMouseDown(null);
    setMouseMoved(false);
  };

  return (
    <div>
      <ScrollArea speed={0.8} className="scroll-container" contentClassName="scrollable-content" horizontal={true} >
        <ReactPanZoom zoom={zoom}>
          <div className="store-map-image-wrapper" 
               style={{position: 'relative', backgroundImage: `url(${floorPlanURL})`, width:700, height:500, backgroundSize: '700px 500px'}}
               onMouseDown={(e) => {setMouseDown({x:e.nativeEvent.offsetX, y:e.nativeEvent.offsetY})}}
               onMouseUp={() => {dropPin()}}
               onMouseMove={() => {if (mouseDown != null) setMouseMoved(true)}}>
            {
              location.x != -1 ? <FontAwesomeIcon icon={faMapPin} size={'lg'} style={{ position: 'absolute', top: location.y-20, left: location.x-6, color: '#44f' }} /> : null
            }                
          </div>    
        </ReactPanZoom>

        <div className="op-floor-plan-zoom">
          <div className="row">
            <div className="col-sm-12">
              <button onClick={() => {setZoom(zoom + 0.2)}} type="button" className="btn btn-default btn-block btn-following-row"><span>+</span></button>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <button onClick={() => {if (zoom > 0.2) setZoom(zoom - 0.2)}} type="button" className="btn btn-default btn-block btn-following-row"><span style={{fontSize: '18px', fontWeight: '600', lineHeight:'22px'}}>-</span></button>
            </div>
          </div>
        </div>                      
      </ScrollArea>        
    </div>
  );
}

const AssetTypeSpecificFormArea = ({toggleMeasureModal, toggleFloorplanModal, floorplanLocation, floorplanRequired, availableAreaTags, availableGenericTags, removeMeasure, measures, metadataTypes, assetImages, onAssetImageChange}) => {
  return (
    <div style={{paddingTop: 15}}>
      <Row>
        <Col xs={12} sm={4}>
          <div className="form-tag">
            <label>{i18next.t('pages.assets.tags')}</label>
            <Field name="genericTags" options={availableGenericTags} component={SelectInput} isMulti />
          </div>
        </Col>
        <Col xs={12} sm={4}>
          <div className="form-tag">
            <label>{i18next.t('pages.assets.area')}</label>
            <Field name="areaTag" options={availableAreaTags} component={SelectInput} isClearable={true} />
          </div>
        </Col>        
        <Col xs={12} sm={4}>
          {floorplanRequired && <div className="form-tag">
            <label>&nbsp;</label>
            <button className="btn btn-default btn-sm" type="button" onClick={() => { toggleFloorplanModal() }}>{i18next.t('pages.assets.floor-plan')}</button>
            &nbsp; { floorplanLocation.x == -1 ? i18next.t('pages.assets.currently-not-set') : i18next.t('pages.assets.currently-set') }
          </div>}
        </Col>
      </Row>

      <br />

      <Row className="grey-box">
        <Col xs={12} sm={12}>
        <div className="oc-mini-card oc-mini-card">
            <div className="panel-heading">
              {i18next.t("pages.assets.measures")}
            </div>
            <div className="inner">
            <AssetMeasuresTable measures={measures} toggleModal={toggleMeasureModal} removeMeasure={removeMeasure} />
          </div>
          </div>
        </Col>
      </Row>

      <br />

      <Row className="grey-box">
        <Col xs={12} sm={6} className="oc-mini-card">
          <div>
            <div className="panel-heading">
              {i18next.t("pages.assets.metadata")}
            </div>
            <div className="inner">
              <AssetMetadataTable metadataTypes={metadataTypes} />
            </div>
          </div>
        </Col>
        <Col xs={12} sm={6} className="oc-mini-card">
          <div>
            <div className="panel-heading">
              {i18next.t("pages.assets.asset-images")}
            </div>
            <div className="inner">
              <AssetImageGallery 
                assetImages={assetImages} 
                onAssetImageChange={onAssetImageChange} 
                onError={(err) => { toast.error(err); }}
              />
          </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const AssetMeasuresTable = ({measures, toggleModal, removeMeasure}) => {
  return (
    <table className='table table-striped'>
      <thead>
        <tr>
          <th>{i18next.t('pages.assets.name')}</th>
          <th>{i18next.t('pages.assets.measure-type')}</th>
          <th>{i18next.t('pages.assets.measured-from')}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {
          measures.map((measure) => {
            return (
            <tr key={`${measure.assetTypeDeviceDataType.id}`}>
              <td>{measure.name}</td>
              <td>{measure.assetTypeDeviceDataType.deviceDataClassification.name}</td>
              <td>{measure.device ? `${measure.device.displayName} : ${measure.deviceDataType.name}` : i18next.t('pages.assets.not-set')}</td>
              <td>
                {
                  measure.device ?
                    <button className="btn btn-default btn-sm" type="button" onClick={() => { toggleModal(measure) }}>{i18next.t('pages.assets.change-device')}</button> :
                    <button className="btn btn-default btn-sm" type="button" onClick={() => { toggleModal(measure) }}>{i18next.t('pages.assets.assign-device')}</button>
                }
                &nbsp;
                {
                  <button className="btn btn-default btn-sm" type="button" onClick={() => { removeMeasure(measure, measure.deviceDataType); }}>Remove</button>
                }
              </td>
            </tr>
            );
          })
        }
      </tbody>
    </table>
  );
};

const AssetMetadataTable = ({metadataTypes}) => {
  return (
    <table className='table'>
      <thead>
        <tr><th>{i18next.t('pages.assets.name')}</th><th>{i18next.t('pages.assets.value')}</th></tr>
      </thead>
      <tbody>
        {
          metadataTypes.map((metadataType) => {
            return (
            <tr key={metadataType.id}>
              <td>{metadataType.name}</td>
              <td>
                <Field 
                  name={`metadata-${metadataType.id}`} 
                  type={metadataType.stringValueFlag ? "text" : "number"} 
                  component={TextInput} 
                />
              </td>
            </tr>
            );
          })
        }
      </tbody>
    </table>
  );
};

const AssignDeviceToMeasureModal = ({show, toggleModal, assignAction, businessGroupId, assigningMeasure}) => {
  return (
    <Modal show={show} onHide={() => toggleModal(null)} dialogClassName="op-floor-plan-modal">
        <Modal.Header closeButton>
          <Modal.Title>{i18next.t('pages.actions.assign-device-to-measure-action')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            assigningMeasure ?
            <AssignDeviceToMeasureTable 
              assignAction={assignAction} 
              businessGroupId={businessGroupId}
              measure={assigningMeasure}
            /> : 
            <div>{i18next.t('loading')}</div>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => toggleModal(null)}>{i18next.t('form-labels.cancel')}</Button>
        </Modal.Footer>
    </Modal>
  );
}

const DEFAULT_SORTED = []; // TODO [{id: 'occurredAt', desc: true}]

const DisplayNameColumnFilter = ({nameFilter, nameFilterChanged}) => {
  const [filterValue, setFilterValue] = useState(nameFilter);
  const [changeTimer, setChangeTimer] = useState(null);

  const filterChange = ({ target }) => {
    setFilterValue(target.value);

    if (changeTimer) {
      clearTimeout(changeTimer);
    }

    setChangeTimer(
      setTimeout(() => {
        nameFilterChanged(target.value);
      }, 500)
    );
  };

  return (
      <div className="filter">
          <i className="table-search-icon" />
          <input
              style={{ width: "100%", margin: "0 auto" }}
              defaultValue={filterValue}
              onChange={filterChange}
              type="text"
              name="search"
              className="table-search-box"
              autoComplete="off"
          />
      </div>
  );
};

const AssignDeviceToMeasureTable = ({assignAction, businessGroupId, measure}) => {
  const [nameFilter, setNameFilter] = useState('');
  const [tableData, setTableData] = useState({ data: [], pageSize: 10, pageCount: 0, loading: false, totalElements: 0, nameFilter: "" });

  const fetchData = (inTableData) => {
    if (inTableData.loading) {
      return;
    }

    const options = BaseTable.buildURLOptions(inTableData, DEFAULT_SORTED);
    options.push({ filterByGroupingId: businessGroupId });
    options.push({ deviceDataClassificationId: measure.assetTypeDeviceDataType.deviceDataClassification.id });
    options.push({ displayNameFilter: inTableData.nameFilter ?? nameFilter });
    
    setTableData({ ...inTableData, loading: true, nameFilter: nameFilter });
    DevicesService.listAllForGroupingAndDeviceDataClassification(options).then((response) => {
      const allTableData = response.devices.flatMap((device) => {
        return device.deviceType.dataTypes
              .filter((dataType) => dataType.deviceDataClassification != null && dataType.deviceDataClassification.id === measure.assetTypeDeviceDataType.deviceDataClassification.id)
              .map((dataType) => ({ displayName: device.displayName, dataTypeToken: dataType.token, device: device, dataType: dataType }));
      });

      setTableData({
          ...inTableData,
          data: allTableData,
          pageCount: response.response.totalPages,
          totalElements: response.response.totalElements,
          loading: false,
          nameFilter: nameFilter
      });
    }).catch((error) => {
      console.error(error);
      toast.error(i18next.t('messages.error-getting-measures'));
    });
  };

  useEffect(() => {
    if (tableData.nameFilter != nameFilter) {
      fetchData({ ...tableData, nameFilter: nameFilter, page: 0 });
    }
  }, [nameFilter]);

  return (
      <div>
        <div style={{paddingBottom:10}}>{i18next.t('pages.assets.select-message')} <b>{measure.name}</b></div>

        <div className="react-table-custom">
          <ReactTable 
            data={tableData.data}
            pages={tableData.pageCount} // Display the total number of pages
            loading={tableData.loading} // Display the loading overlay when we need it
            totalElements={tableData.totalElements}
            page={tableData.page}
            onFetchData={fetchData}
            manual
            showPaginationTop
            defaultPageSize={10}
            columns={[
              {
                Header: i18next.t('pages.assets.name'),
                accessor: "displayName",
                sortable: true,
                minResizeWidth: 200,
                width: 400,
                filterable: true,
                Filter: <DisplayNameColumnFilter nameFilter={nameFilter} nameFilterChanged={setNameFilter} />
              }, {
                Header: i18next.t('pages.assets.data-point'),
                Cell: ({value}) => i18next.t(`device-data-types.${value}`),
                accessor: "dataTypeToken",
                sortable: false,
                minResizeWidth: 15
              }, {
                Cell: ({original}) => (
                  <div className="text-center">
                    <button className="btn btn-sm btn-default" onClick={() => assignAction(original.device, original.dataType, measure)}>
                      {i18next.t('pages.assets.assign-device')}
                    </button>
                  </div>),
                sortable: false,
                minResizeWidth: 15,
                width: 200
              }
            ]}
          />
        </div>
      </div> 
  );
};

export default reduxForm({ form: 'AssetForm', validate })(AssetForm);
